import React, { Component } from "react";
// import { Link } from "react-router-dom";
import Img1 from "../Images/img1.jpg";
import Img2 from "../Images/img2.jpg";
import Img3 from "../Images/img3.jpg";
import Img4 from "../Images/img4.jpg";
import Img5 from "../Images/img5.jpg";
import Img6 from "../Images/img6.jpg";

class Overview extends Component {
  state = {};
  render() {
    return (
      <div className="container">
        <h1 className="page-header text-center head">
          Facilities at the centre
        </h1>
        <p>
          The centre is designed to accommodate the physical needs of pesons
          with disabilities accessibility of the physical structure and those
          without disabilities. The centre is euipped with modern use of
          technological devicees and materials for interventional purposes.
        </p>
        <div className="overview-photos row">
          <a className="overview-photo col-md-3" href={Img1}>
            <div>
              <img className="img-fluid" src={Img1} alt="Center" />
            </div>
            <figcaption className="text-center in">
              Well-equipped facility for learning with all modern tools
            </figcaption>
          </a>

          <a className="overview-photo col-md-3" href={Img2}>
            <div>
              <img className="img-fluid" src={Img2} alt="Center" />
            </div>
            <figcaption className="text-center in">
              Well-eqipped for learning
            </figcaption>
          </a>

          <a className="overview-photo col-md-3" href={Img3}>
            <div>
              <img className="img-fluid" src={Img3} alt="Center" />
            </div>
            <figcaption className="text-center in">
              An on-going session
            </figcaption>
          </a>

          <a className="overview-photo col-md-3" href={Img4}>
            <div>
              <img className="img-fluid" src={Img4} alt="Center" />
            </div>
            <figcaption className="text-center in">
              A disability-friendly facility
            </figcaption>
          </a>

          <a className="overview-photo col-md-3" href={Img5}>
            <div>
              <img className="img-fluid" src={Img5} alt="Center" />
            </div>
            <figcaption className="text-center in">Front view</figcaption>
          </a>

          <a className="overview-photo col-md-3" href={Img6}>
            <div>
              <img className="img-fluid" src={Img6} alt="Center" />
            </div>
            <figcaption className="text-center in">The Porch</figcaption>
          </a>
        </div>
      </div>
    );
  }
}

export default Overview;
